namespace GeniuzPOS.InventoryReport {
    export interface IcReport04ListData extends Serenity.ListRequest {
        Header?: IcReport04Row;
    }
}
